import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function AdminPage() {
  const [config, setConfig] = useState(null);
  const [neuerKey, setNeuerKey] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [showKey, setShowKey] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/admin/config').then(res => setConfig(res.data)).catch(() => {});
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!neuerKey.trim()) return;
    setSaving(true); setMessage('');
    try {
      await api.post('/admin/apikey', { apikey: neuerKey.trim() });
      setMessage('✅ API Key erfolgreich gespeichert!');
      setNeuerKey('');
      api.get('/admin/config').then(res => setConfig(res.data));
    } catch (err) {
      setMessage('❌ Fehler: ' + (err.response?.data?.error || err.message));
    } finally { setSaving(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', padding: 16 }}>
      <div style={{ maxWidth: 500, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#6366f1', cursor: 'pointer', fontSize: 14 }}>← Zurück</button>
          <h1 style={{ color: '#f1f5f9', fontSize: 18, fontWeight: 700 }}>⚙️ Einstellungen</h1>
        </div>

        {/* Aktueller Status */}
        {config && (
          <div style={{ background: '#1e293b', borderRadius: 12, padding: 16, marginBottom: 16 }}>
            <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
              📊 Aktueller Status
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #334155' }}>
                <span style={{ color: '#64748b', fontSize: 13 }}>OpenAI API Key</span>
                <span style={{ color: config.openai_key_gesetzt ? '#34d399' : '#f87171', fontSize: 13, fontWeight: 600 }}>
                  {config.openai_key_gesetzt ? `✅ ${config.openai_key_preview}` : '❌ Nicht gesetzt'}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #334155' }}>
                <span style={{ color: '#64748b', fontSize: 13 }}>Ollama URL</span>
                <span style={{ color: '#94a3b8', fontSize: 13 }}>{config.ollama_url}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
                <span style={{ color: '#64748b', fontSize: 13 }}>KI-Modell</span>
                <span style={{ color: '#94a3b8', fontSize: 13 }}>{config.ollama_model}</span>
              </div>
            </div>
          </div>
        )}

        {/* API Key ändern */}
        <div style={{ background: '#1e293b', borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
            🔑 OpenAI API Key ändern
          </h3>
          <p style={{ color: '#64748b', fontSize: 13, marginBottom: 14 }}>
            Den API Key findest du unter platform.openai.com/api-keys
          </p>
          <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div style={{ position: 'relative' }}>
              <input
                type={showKey ? 'text' : 'password'}
                value={neuerKey}
                onChange={e => setNeuerKey(e.target.value)}
                placeholder="sk-proj-..."
                style={{ background: '#0f172a', border: '1px solid #334155', color: '#f1f5f9', padding: '12px 44px 12px 12px', borderRadius: 8, fontSize: 14, outline: 'none', width: '100%' }}
              />
              <button type="button" onClick={() => setShowKey(!showKey)}
                style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 16 }}>
                {showKey ? '🙈' : '👁️'}
              </button>
            </div>
            {message && (
              <div style={{ color: message.startsWith('✅') ? '#34d399' : '#f87171', fontSize: 13 }}>
                {message}
              </div>
            )}
            <button type="submit" disabled={saving || !neuerKey.trim()} style={{
              background: saving || !neuerKey.trim() ? '#334155' : '#6366f1',
              color: saving || !neuerKey.trim() ? '#64748b' : 'white',
              border: 'none', padding: '12px', borderRadius: 8,
              fontSize: 14, fontWeight: 600, cursor: saving || !neuerKey.trim() ? 'not-allowed' : 'pointer'
            }}>
              {saving ? '⏳ Speichern...' : '💾 API Key speichern'}
            </button>
          </form>
        </div>

        <div style={{ background: '#1e293b', borderRadius: 12, padding: 16 }}>
          <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
            💡 Hinweise
          </h3>
          <ul style={{ color: '#64748b', fontSize: 13, paddingLeft: 20, lineHeight: 2 }}>
            <li>API Key wird sicher auf dem NAS gespeichert</li>
            <li>Kein Neustart notwendig nach dem Speichern</li>
            <li>Whisper-1 kostet ca. 0,006$ pro Minute Audio</li>
            <li>30-Minuten Meeting ≈ 0,18$</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
